export const SEARCH_RESULTS_PAGE_URL_SLUG = 'search';
